<template>
  <div class="case-file-view">
    <div class="header">
      <el-button size="small" type="primary" icon="el-icon-refresh" @click="getFileList">刷新</el-button>
    </div>
    <el-table :data="fileTypes" border style="width: 100%" v-loading="loading">
      <el-table-column prop="name" label="材料类型" width="180"></el-table-column>
      <el-table-column label="上传材料">
        <template slot-scope="scope">
          <el-table :data="Object.entries(scope.row.files)" border size="mini">
            <el-table-column prop="[1]" label="材料名称" width="200"></el-table-column>
            <el-table-column label="状态" width="80">
              <template slot-scope="props">
                <el-tag :type="getFileListByKey(props.row[0]).length > 0 ? 'success' : 'danger'" size="small">
                  {{ getFileListByKey(props.row[0]).length > 0 ? '已上传' : '未上传' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="已上传文件">
              <template slot-scope="props">
                <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                  <div v-for="(file, index) in getFileListByKey(props.row[0])" :key="index" style="display: flex; align-items: center;">
                    <el-tag
                      size="small"
                      style="cursor: pointer;"
                      @click="downloadFile(file)"
                    >
                      {{ file.file_name }}
                      <i class="el-icon-download" style="margin-left: 5px;"></i>
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import caseJs from './case.js'
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: 'CaseFileView',
  data() {
    return {
      loading: false,
      caseId: '',
      fileTypes: [
        {
          type: 1,
          name: '起诉材料',
          files: {
            complaint_letter: '起诉状（现章）',
            evidence_list: '证据清单（电子章）',
            owner_identity: '业主身份信息',
            service_contract: '物业服务合同 / 前期物业服务合同',
            reminder_letter: '催件函'
          }
        },
        {
          type: 2,
          name: '公司主体资格证明',
          files: {
            business_license: '营业执照副本复印件（现章）',
            legal_representative_id: '法定代表人身份证明书（现章）',
            legal_representative_card: '法定代表人身份证复印件（现章）',
            authorization_letter: '授权委托书（现章）'
          }
        },
        {
          type: 3,
          name: '员工代理所需材料',
          files: {
            employee_id: '员工身份证复印件',
            labor_contract: '劳动合同',
            social_insurance: '社保证明'
          }
        }
      ],
      fileList: []
    }
  },
  mounted() {
    this.getCaseIdFromUrl();
    if (this.caseId) {
      this.getFileList();
    }
  },
  methods: {
    getCaseIdFromUrl() {
      this.caseId = this.$route.query.case_id || this.$route.query.id || '';
      if (!this.caseId) {
        this.$message.error('请提供案件ID');
      }
    },
    getFileList() {
      if (!this.caseId) return;
      
      this.loading = true;
      ButlerHttp.get('LawCaseFiles/getFileList', { case_id: this.caseId }, res => {
        this.loading = false;
        if (res.code) {
          this.fileList = res.data || [];
        } else {
          this.$message.error(res.msg || '获取资料失败');
        }
      });
    },
    getFileListByKey(file_key) {
      if (!this.fileList) {
        return [];
      }
      return this.fileList.filter(f => f.file_key === file_key);
    },
    downloadFile(file) {
      if (file.file_url) {
        let open_url = caseJs.getFileUrl(file.file_url);
        window.open(open_url);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.case-file-view {
  padding: 20px;
}

.header {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/law_case/case_file_view.vue